import { render, staticRenderFns } from "./ModifyNickname.vue?vue&type=template&id=5846fd4e"
import script from "./ModifyNickname.vue?vue&type=script&lang=js"
export * from "./ModifyNickname.vue?vue&type=script&lang=js"
import style0 from "./ModifyNickname.vue?vue&type=style&index=0&id=5846fd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports